module.exports = __webpack_public_path__ + "static/media/share_course.86f7d915.svg";